import { gql } from "@urql/core";

export const GET_CATEGORY_INFO = gql`
  query category_info($id: Int!) {
    category(id: $id) {
      id
      name
      description
      meta_title
      meta_description
      children_count
      url_path
      mobile_image
      desktop_image
      image
      thumbnail
      thumbnail_image
      collection_image
      banner_image
    }
  }
`;
export const GET_CATEGORY_INFO_WITH_CHILDREN = gql`
  query category_info_with_children($filters: CategoryFilterInput) {
    categoryList(filters: $filters) {
      id
      name
      description
      meta_title
      meta_description
      children_count
      url_path
      mobile_image
      desktop_image
      image
      thumbnail
      thumbnail_image
      collection_image
      banner_image
      children {
        id
        name
        url_path
        thumbnail
        children {
          id
          name
          url_path
          thumbnail
          children {
            id
            name
            url_path
            thumbnail
          }
        }
      }
    }
  }
`;
